import React, { FC } from "react";
import {
  Box,
  InputAdornment,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { Search } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

import type { ContributorItem } from "../PaygapPositionRoleOverview";

interface DetailTableProps {
  topContributorData: ContributorItem[];
  filteredContributorData: ContributorItem[];
  filterText: string;
  onFilterChange: (value: string) => void;
}

export const DetailTable: FC<DetailTableProps> = ({
  topContributorData,
  filteredContributorData,
  filterText,
  onFilterChange,
}) => {
  const { t } = useTranslation();

  if (topContributorData.length === 0) {
    return (
      <Box display="flex" alignItems="center" justifyContent="center" height={300}>
        <Typography variant="body2" color="text.secondary">
          {t("paygap.payGapPerRole.noData")}
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      <Box mb={2}>
        <TextField
          fullWidth
          size="small"
          placeholder={t("paygap.payGapPerRole.search")}
          value={filterText}
          onChange={(e) => onFilterChange(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search />
              </InputAdornment>
            ),
          }}
        />
      </Box>
      <TableContainer component={Paper} variant="outlined">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <Typography variant="subtitle2" fontWeight="bold">
                  {t("paygap.payGapPerRole.positionAndWorkerId")}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="subtitle2" fontWeight="bold">
                  {t("paygap.payGapPerRole.paygapContribution")}
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredContributorData.length === 0 ? (
              <TableRow>
                <TableCell colSpan={2} align="center">
                  <Typography variant="body2" color="text.secondary">
                    {t("paygap.payGapPerRole.noData")}
                  </Typography>
                </TableCell>
              </TableRow>
            ) : (
              filteredContributorData.map((item, index) => (
                <TableRow key={`${item.key}-${index}`}>
                  <TableCell>{item.key}</TableCell>
                  <TableCell>{item.value}</TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};
